export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14078.6919492b.jpg";